import constate from 'constate';
import { useCallback, useReducer } from 'react';

import { initialState, reducer, ActionType } from './dib-store-reducer';

const isAnswerCorrect = (answer: string, correctAnswer: string): boolean => {
  if (!answer || !correctAnswer) {
    return false;
  }
  return answer.toLowerCase().trim() === correctAnswer.toLowerCase().trim();
};

function useDibStore() {
  const [store, dispatch] = useReducer(reducer, initialState);

  const setAnswer = useCallback(
    (key: number, answer: string, correctAnswer: string) =>
      dispatch({
        type: ActionType.SetAnswer,
        payload: {
          key,
          value: { answer, correct: isAnswerCorrect(answer, correctAnswer) },
        },
      }),
    []
  );

  const reset = useCallback(() => dispatch({ type: ActionType.Reset }), []);

  const resetAnswers = useCallback(
    () => dispatch({ type: ActionType.ResetAnswers }),
    []
  );

  const markAsComplete = useCallback(
    () => dispatch({ type: ActionType.Complete }),
    []
  );

  const resetIncorrectAnswers = useCallback(
    () => dispatch({ type: ActionType.ResetIncorrectAnswers }),
    []
  );
  const setPossibleAnswers = useCallback(
    (value: string[]) =>
      dispatch({ type: ActionType.SetPossibleAnswers, payload: value }),
    []
  );

  const setErrorsVisible = useCallback(
    (value: boolean) =>
      dispatch({ type: ActionType.SetErrorsVisible, payload: value }),
    []
  );

  const fillAnswers = useCallback(
    (value: number) =>
      dispatch({ type: ActionType.FillAnswers, payload: value }),
    []
  );

  const actions = {
    setAnswer,
    reset,
    setPossibleAnswers,
    setErrorsVisible,
    resetIncorrectAnswers,
    resetAnswers,
    markAsComplete,
    fillAnswers,
  };

  return { store, actions };
}

export const [DibStoreProvider, useDibContext] = constate(useDibStore);
